import pL from 'js-regex-pl';

export default {
  data() {
    return {
      patterns: {
        numbersOnly: '^[\\d\\s]+$',
        lettersOnly: `^[\\s${pL}]+$`,
        lettersAndNumbers: `^[${pL}0-9\\s,. \\-\']+$`,
        paymentAmount: '^\\d{0,6}(\\.\\d{0,2})?$',
        postcode: '^[a-zA-Z0-9\\s\\-]+$',
        name: `[\\s,.\'\\-${pL}]+`,
        names: '^[A-Za-z\\-\']+( [A-Za-z\\-\']+)*$',
        password: '(?=.*\\d)(?=.*[A-Z]).{6,}',
        maxChar500: `^(?!.*[><]+)([${pL}0-9\\s]{0,500})$`,
        telephone: '^\\+?[\\d\\s]{7,}$',
        email: '[^@\\s]+@[^@\\s]+\\.[^@\\s]+'
      },
      titles: {
        numbersOnly: 'Enter numbers only',
        lettersOnly: 'Enter letters only',
        lettersAndNumbers: 'Enter letters and numbers only',
        paymentAmount: 'Enter valid number to two decimal places only. Minimum £1. Cannot exceed full balance',
        postcode: 'Enter a valid postcode. Letters and numbers',
        name: 'Enter letters, hyphens and apostrophes only',
        password: 'Minimum 6 characters including 1 upper case and 1 number',
        maxChar500: 'Enter letters and numbers only. Maximum 500 characters',
        telephone: 'Enter numbers only (prefixed with a "+" if applicable), minimum 7 characters',
        email: 'Enter a valid email address',
      }
    };
  }
};
